import { watch } from 'vue'

/**
 * Старт аналитики на клиенте (ТЗ §5.3, §11.2): загрузить конфиг витрины,
 * восстановить решение по cookies и инициализировать счётчик — сразу, если
 * согласие не требуется, либо лениво после opt-in из CMP-баннера
 */
export default defineNuxtPlugin({
  name: 'analyticsRoot:plugin',
  // host-loader должен отработать до loadConfig: getConfig() шлёт appConfig.host в
  // путь /showcases/v1/{host}/analytics/config. Без этой зависимости плагин стартует
  // раньше резолва хоста → запрос без хоста → 404 → конфиг пуст → счётчик не поднимается
  dependsOn: ['alt-container:plugin', 'host-loader:plugin'],
  parallel: true,
  async setup() {
    const { support, store } = useAnalytics()
    const { restore, analyticsAllowed } = useConsent()

    await support.loadConfig().catch(() => undefined)
    restore()

    support.initMetrikaIfAllowed(analyticsAllowed())

    // Переинициализация при позднем приходе конфига или opt-in из CMP-баннера
    // (initMetrikaIfAllowed идемпотентен — повторный вызов при инициализированном счётчике no-op)
    watch(
      [() => store.config, () => store.consent],
      () => support.initMetrikaIfAllowed(analyticsAllowed()),
    )
  },
})
